import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "value"];

  connect() {
    this.updateValue();
    this.inputTarget.addEventListener("input", this.updateValue.bind(this));
  }

  updateValue() {
    this.valueTarget.textContent = this.inputTarget.value;
  }
}
